import { client } from '@/lib/httpClient';
import type { 
    UserAllowedCompany, 
    UserAllowedCategory,
    UserAllowedCompanyEntry,
    UserAllowedCategoryEntry,
    UserAllowedCompanyEntryResponse,
    UserAllowedCategoryEntryResponse
} from '@/types/userPermissions.types';
import type { ActionStatus } from '@/types/api.types';
import { userAllowedCompanySchema, userAllowedCategorySchema } from '@/schemas/userPermissions.schemas';

export const userPermissionsApi = {
    // Allowed Companies
    getAllowedCompanies: async (userId: string): Promise<UserAllowedCompany[]> => {
        const response = await client.get<UserAllowedCompany[]>(
            `/api/v1/users/${userId}/allowed_companies`
        );
        return response.data;
    },

    addAllowedCompany: async (userId: string, data: UserAllowedCompanyEntry): Promise<UserAllowedCompanyEntryResponse> => {
        const validated = userAllowedCompanySchema.parse(data);
        const response = await client.post<UserAllowedCompanyEntryResponse>(
            `/api/v1/users/${userId}/allowed_companies`,
            validated
        );
        return response.data;
    },

    deleteAllowedCompany: async (userId: string, allowedCompanyId: string): Promise<ActionStatus> => {
        const response = await client.delete<ActionStatus>(
            `/api/v1/users/${userId}/allowed_companies/${allowedCompanyId}`
        );
        return response.data;
    },

    // Allowed Categories
    getAllowedCategories: async (userId: string): Promise<UserAllowedCategory[]> => {
        const response = await client.get<UserAllowedCategory[]>(
            `/api/v1/users/${userId}/allowed_categories`
        );
        return response.data;
    },

    addAllowedCategory: async (userId: string, data: UserAllowedCategoryEntry): Promise<UserAllowedCategoryEntryResponse> => {
        const validated = userAllowedCategorySchema.parse(data);
        const response = await client.post<UserAllowedCategoryEntryResponse>(
            `/api/v1/users/${userId}/allowed_categories`,
            validated
        );
        return response.data;
    },

    deleteAllowedCategory: async (userId: string, allowedCategoryId: string): Promise<ActionStatus> => {
        const response = await client.delete<ActionStatus>(
            `/api/v1/users/${userId}/allowed_categories/${allowedCategoryId}`
        );
        return response.data;
    }
};
